import React from 'react';

import { GlobalSizing } from '../GlobalSizing';
import { GlobalColors } from '../GlobalColors';
import { GlobalComponentStyles } from '../GlobalComponentStyles';

export const GlobalStyles = () => (
  <>
    <GlobalSizing />
    <GlobalColors />
    <GlobalComponentStyles />
  </>
);
